module.exports = __webpack_public_path__ + "img/black.e7a6bef7.png";